module.exports = require("npm:ieee754@1.1.13/index.js");